import { render } from "./Modal.vue?vue&type=template&id=5f7088f2"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5f7088f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f7088f2', script)) {
    api.reload('5f7088f2', script)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=5f7088f2", () => {
    api.rerender('5f7088f2', render)
  })

}

script.__file = "resources/js/Components/Modal.vue"

export default script